var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-size"},[_c('buttons-group',{attrs:{"items":_vm.filterItems,"indexStep":_vm.index,"indexDesabilitado":_vm.desabilitarTabelaDominio,"disabledAll":true,"width":260},on:{"click":_vm.getIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }